import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '@contler/utils';
import { TranslateModule } from '@ngx-translate/core';
import { first, forkJoin, map } from 'rxjs';

import { ImageSkeletonComponent } from '../image-skeleton/image-skeleton.component';

@Component({
  selector: 'ctr-header',
  imports: [MatIconModule, TranslateModule, ImageSkeletonComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() title: string | null = '';
  @Input() imageUrl: string | undefined;
  @Input() backUrl: string | undefined;
  @Input() showBack = true;
  @Input() showMenu = true;

  @Output() menuClick = new EventEmitter<void>();
  private url = '';
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private navigationService = inject(NavigationService);

  constructor() {
    const currentNavigation = this.router.currentNavigation();

    forkJoin([
      this.route.url.pipe(
        first(),
        map((segments) => segments.join('/') as string),
      ),
      this.route.queryParams.pipe(
        first(),
        map((params) => params['backUrl']),
      ),
    ]).subscribe(([url, backQuery]) => {
      this.url = url;
      if (currentNavigation?.extras.state && currentNavigation.extras.state['backUrl']) {
        this.navigationService.setNavigation(this.url, currentNavigation.extras.state['backUrl']);
      } else if (backQuery) {
        this.backUrl = backQuery;
        // this.navigationService.setNavigation(this.url, backQuery);
      }
    });
  }

  goBack() {
    const backDirection = this.navigationService.getNavigation(this.url);
    if (backDirection) {
      this.router.navigate([backDirection]);
    } else if (this.backUrl) {
      window.location.href = this.backUrl;
    } else {
      window.history.back();
    }
  }

  goMenu() {
    this.menuClick.emit();
  }
}
